import { FC } from "react"
import { DashboardSectionProps } from "./types"
import { APP_DESCRIPTION } from "./constants"
import { AppButtonCard } from "./app-button-card"

const DashboardSection: FC<DashboardSectionProps> = ({
  title,
  apps,
  getDisableReason,
  onAppClick,
  onLockClick,
}) => {
  if (apps.length === 0) return null

  return (
    // Tile column is sized for FIVE 128px cards + 12px gaps (688px) so the
    // Offense row fits QB/RB/TE/OL/WR on one line; every section shares the
    // same template, keeping all rows left-aligned at the same x. gap-x keeps
    // clear air between the section text and the tiles even on narrow widths.
    <div className="grid w-full grid-cols-[minmax(0,1fr)_688px] items-end gap-x-12">
      <div>
        <h2 className="text-left text-2xl">{title}</h2>
        <p className="text-left text-[14px] text-[#6B7280]">{APP_DESCRIPTION}</p>
      </div>
      <div className="flex flex-row justify-start gap-[12px]">
        {apps.map((item) => {
          const disableReason = getDisableReason(item)
          const isDisabled = disableReason !== null
          const appKey = `${item.appId}-${item.index}`
          return (
            <AppButtonCard
              key={appKey}
              item={item}
              isDisabled={isDisabled}
              disableReason={disableReason}
              onClick={() => onAppClick(item, isDisabled)}
              // The lock icon opens the "why is this locked" modal for ANY
              // disabled reason (subscription / session / offline).
              onLockClick={
                isDisabled && onLockClick
                  ? () => onLockClick(item, disableReason)
                  : undefined
              }
            />
          )
        })}
      </div>
    </div>
  )
}

export { DashboardSection }
